"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

require("../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ValueItem = _interopRequireDefault(require("../layout/ValueItem"));

var _classnames = _interopRequireDefault(require("classnames"));

"use strict";

/**
 * @class StatusIndicator
 * @desc displays a small circular status indicator
 *
 * @param {string} [data-id="status-indicator"]
 *     Defines the "data-id" for top-level HTML container.
 * @param {StatusIndicator.statusTypes} [type=MessageTypes.NOTICE]
 *     Type of icon to display (MessageTypes.NOTICE, MessageTypes.ERROR, MessageTypes.WARNING)
 * @param {string} [className]
 *     CSS classes to add on the top-level HTML container.
 * @param {boolean} [inline=false]
 *     When true, the value item displays inline
 *
 * @example
 *    <StatusIndicator>
 *        foobar
 *    </StatusIndicator>
 */

/**
 * @enum {string}
 * @alias StatusIndicator.statusTypes
 * @desc Enum for the different types of status
 */
var statusTypes = {
  /** notice */
  NOTICE: "notice",

  /** error */
  ERROR: "error",

  /** warning */
  WARNING: "warning",

  /** success */
  SUCCESS: "success",

  /** empty */
  EMPTY: "empty"
};

var _getIcon = function _getIcon(type) {
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "status-indicator--icon status-indicator--icon__".concat(type)
  });
};

var StatusIndicator = function StatusIndicator(_ref) {
  var children = _ref.children,
      className = _ref.className,
      dataId = _ref["data-id"],
      inline = _ref.inline,
      type = _ref.type;
  return /*#__PURE__*/_react.default.createElement(_ValueItem.default, {
    className: (0, _classnames.default)("status-indicator", className),
    "data-id": dataId,
    icon: _getIcon(type),
    inline: inline
  }, children);
};

StatusIndicator.propTypes = {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  inline: _propTypes.default.bool,
  type: _propTypes.default.oneOf((0, _values.default)(statusTypes))
};
StatusIndicator.defaultProps = {
  "data-id": "status-indicator",
  inline: false
};
StatusIndicator.Types = statusTypes;
StatusIndicator.statusTypes = statusTypes; // new standard

var _default = StatusIndicator;
exports.default = _default;
module.exports = exports["default"];